<template>
  <div class="customer-User-manage-box">
    <div class="customer-User-condition-box">
      <el-form :inline="true" :model="condition" size="small">
        <el-form-item label="业主用户编号">
          <el-input v-model.trim="condition.name" placeholder="业主用户编号" style="width: 120px"></el-input>
        </el-form-item>
        <el-form-item label="业主用户名称">
          <el-input v-model.trim="condition.realName" placeholder="业主用户名称" style="width: 120px"></el-input>
        </el-form-item>
        <el-form-item label="手机">
          <el-input v-model.trim="condition.mobile" placeholder="手机" style="width: 120px"></el-input>
        </el-form-item>
        <el-form-item label="账户状态">
          <el-select v-model="condition.enabled" style="width: 100px" placeholder="账户状态">
            <el-option label="全部" :value="null"></el-option>
            <el-option label="启用" :value="1"></el-option>
            <el-option label="停用" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="fetchData()" size="small">查找</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="div-hr"></div>
    <div class="op-box">
      <div style="float: left">
        <el-button size="mini" type="primary" @click="add" icon="el-icon-plus" round>添加</el-button>
        <el-button size="mini" type="text" @click="edit"><i><svg-icon style="width:1.2em; height: 1.2em" icon-class="修改"></svg-icon></i>&nbsp;修改</el-button>
        <el-button size="mini" style="color: #E6A23C" type="text" @click="dialogResetPasswd"><i><svg-icon style="width:1.2em; height: 1.2em" icon-class="重置密码"></svg-icon></i>&nbsp;重置密码</el-button>
        <el-button size="mini" style="color: #F56C6C" type="text" @click="remove"><i><svg-icon style="width:1.2em; height: 1.2em" icon-class="停用"></svg-icon></i>&nbsp;删除</el-button>
      </div>
      <div style="float: right">
        <div class="opreation">
          <div class="download">
            <a href="/static/TenantTemplate.xlsx">模版下载</a>
          </div>&nbsp;&nbsp;&nbsp;&nbsp;
          <div style="float: right">
            <vue-xlsx-table style="background-color: #00b9c3" @on-select-file="handleSelectedFile">
              用户信息上传
            </vue-xlsx-table>
          </div>
        </div>
      </div>
    </div>
    <div class="customer-User-table-box">
      <el-table class="customer-User-table" size="small" stripe :data="customerUsers"
                height="100%" width="100%"
                highlight-current-row
                :header-row-style="{color:'black'}"
                @row-click="currClick">

        <el-table-column
                prop="realName"
                align="center"
                label="业主用户名称">
        </el-table-column>
        <el-table-column
                prop="name"
                align="center"
                label="业主用户编码">
          <!--<template slot-scope="scope">
            <span>{{ getCustomerRoleNamesByIds(scope.row.customerRoleIds) }}</span>
          </template>-->
        </el-table-column>
        <el-table-column
                prop="contactPerson"
                align="center"
                label="联系人">
        </el-table-column>
        <el-table-column
                prop="mobile"
                align="center"
                label="手机">
        </el-table-column>
        <el-table-column
                prop="email"
                align="center"
                label="电子邮箱">
        </el-table-column>
        <el-table-column
                prop="alarmReceivingMode"
                align="center"
                label="报警接收方式">
          <template slot-scope="scope">
            <span>{{ receivingModeMap[scope.row.alarmReceivingMode] }}</span>
          </template>
        </el-table-column>
        <el-table-column
                prop="enabled"
                align="center"
                label="账户状态">
          <template slot-scope="scope">
            <span>{{ scope.row.enabled === 1 ? '启用': '停用' }}</span>
          </template>
        </el-table-column>
        <el-table-column
                prop="address"
                align="center"
                label="用户地址">
        </el-table-column>
        <el-table-column
                prop="createDate"
                align="center"
                label="创建日期">
          <template slot-scope="scope">
            <span>{{ formatTime(scope.row.createDate) }}</span>
          </template>
        </el-table-column>
        <!--<el-table-column
                prop="reportReceivingMode"
                align="center"
                label="报表接受方式">
          <template slot-scope="scope">
            <span>{{ receivingModeMap[scope.row.reportReceivingMode] }}</span>
          </template>
        </el-table-column>-->
        <el-table-column
                prop="deadline"
                align="center"
                label="有效截止日期">
          <template slot-scope="scope">
            <span>{{ formatTime(scope.row.deadline) }}</span>
          </template>
        </el-table-column>
        <el-table-column
                prop="note"
                align="center"
                label="备注">
        </el-table-column>
      </el-table>
    </div>
    <div class="customer-User-page-box">
      <el-pagination
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="page.current"
              :page-sizes="[10, 20, 30, 50, 100]"
              :page-size="pagesize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="page.total">
      </el-pagination>
    </div>

    <el-dialog
            :visible.sync="dialogVisible"
            width="45rem"
            top="15vh"
            size="small"
    >
      <template slot="title">
        {{ typeof currCustomerUser.id === 'undefined' || currCustomerUser.id === null || currCustomerUser.id === '' ? '添加': '编辑'}}业主用户
      </template>

      <div style="display: flex; justify-content: center">
        <el-form ref="form" :model="currCustomerUser" :rules="rules" label-width="110px" size="small">
          <div class="item-group">
            <el-form-item label="业主用户名称" prop="realName" >
              <el-input v-model="currCustomerUser.realName" @blur="currCustomerUser.realName = currCustomerUser.realName.replace(/\s/g,'')" style="width: 12rem"></el-input>
            </el-form-item>
            <el-form-item label="业主用户编码" prop="name">
              <el-input v-model="currCustomerUser.name" @blur="currCustomerUser.name = currCustomerUser.name.replace(/\s/g,'')" style="width: 12rem"></el-input>
            </el-form-item>
          </div>

          <div class="item-group" v-if="typeof currCustomerUser.id === 'undefined' || currCustomerUser.id === null || currCustomerUser.length === 0">
            <el-form-item label="输入密码" prop="password">
              <el-input type="password" v-model="currCustomerUser.password" style="width: 12rem"></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="checkPassword">
              <el-input type="password" v-model="currCustomerUser.checkPassword" style="width: 12rem"></el-input>
            </el-form-item>
          </div>

          <el-form-item label="联系人" prop="contactPerson">
            <el-input v-model="currCustomerUser.contactPerson" style="width: 33.25rem"></el-input>
          </el-form-item>

          <div class="item-group">
            <el-form-item label="手机" prop="mobile">
              <el-input v-model="currCustomerUser.mobile" style="width: 12rem"></el-input>
            </el-form-item>
            <el-form-item label="电子邮箱" prop="email">
              <el-input type="email" v-model="currCustomerUser.email"  style="width: 12rem"></el-input>
            </el-form-item>
          </div>

          <div class="item-group">
            <el-form-item label="账户状态">
              <el-select v-model="currCustomerUser.enabled" placeholder="账户状态"  style="width: 12rem">
                <el-option label="启用" :value="1"></el-option>
                <el-option label="停用" :value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="报警接收方式" prop="alarmReceivingMode">
              <el-select v-model="currCustomerUser.alarmReceivingMode" style="width: 12rem">
                <el-option label="不接收" :value="0"></el-option>
                <el-option label="短信" :value="1"></el-option>
                <el-option label="邮件" :value="2"></el-option>
                <el-option label="短信+邮件" :value="3"></el-option>
              </el-select>
            </el-form-item>
          </div>

          <div class="item-group">

          </div>

          <el-form-item label="有效截止日期" prop="deadline">
            <el-date-picker
                    v-model="currCustomerUser.deadline"
                    type="date"
                    placeholder="选择日期"  style="width: 12rem">
            </el-date-picker>
          </el-form-item>

          <el-form-item label="地址" prop="address">
            <el-input type="textarea"  v-model="currCustomerUser.address"  style="width: 33.25rem"></el-input>
          </el-form-item>

          <el-form-item label="备注" prop="note">
            <el-input type="textarea"  v-model="currCustomerUser.note"  style="width: 33.25rem"></el-input>
          </el-form-item>

        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="small">取消</el-button>
        <el-button type="primary" @click="save" size="small">保存</el-button>
      </span>
    </el-dialog>

    <el-dialog
            :visible.sync="resetDialogVisible"
            width="550px"
            top="15vh"
            size="small"
    >
      <template slot="title">
        重置密码
      </template>

      <div style="display: flex; justify-content: center">
        <el-form ref="resetForm" :model="resetCustomerUser" :rules="resetRules" label-width="110px" size="small">

          <!--<div class="item-group">-->
            <el-form-item label="输入新密码" prop="password">
              <el-input type="password" v-model="resetCustomerUser.password"></el-input>
            </el-form-item>
            <el-form-item label="确认新密码" prop="checkPassword">
              <el-input type="password" v-model="resetCustomerUser.checkPassword"></el-input>
            </el-form-item>
          <!--</div>-->

        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="resetDialogVisible = false" size="small">取消</el-button>
        <el-button type="primary" @click="resetPasswd" size="small">保存</el-button>
      </span>
    </el-dialog>
    <!--<el-dialog
            :visible.sync="removeDialogVisible"
            width="550px"
            top="15vh"
            size="small"
    >
      <template slot="title">
        删除提示
      </template>

      <div style="display: flex; justify-content: center">
        删除业主用户后数据会永久丢失！谨慎删除！
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="removeDialogVisible = false" size="small">取消</el-button>
        <el-button type="primary" @click="deleteTenant" size="small">确认</el-button>
      </span>
    </el-dialog>-->
  </div>
</template>

<script>
  import { getCustomerUsers, saveCustomerUser, updateCustomerUserSimp, verifyCustomerUser,deleteCustomerUser,saveBatchTenant,verifyBatchTenant,downLoad } from '@/api/customerUser'
  import { selectCustomerUserMeter } from '@/api/CustomerUserMeter'
  import { getCustomerRoles } from '@/api/customerRole'
  import { getCurrDayZero, getCurrDayLast, formatToDay } from '@/utils/time'
  import { mapGetters } from 'vuex'
  import { Message, MessageBox } from 'element-ui'
  import { identifierRegex, mobileRegex, emailRegex } from '@/utils/validate'
  import { selectRoleByCode } from "@/api/customerRole"

  export default {
    name: 'UserManage',
    data() {
      var validatePass = (rule, value, callback) => {
        if (typeof value === 'undefined' || value === null || value === '') {
          callback(new Error('请输入密码'))
        } else {
          if (this.currCustomerUser.checkPassword !== '' && typeof this.currCustomerUser.checkPassword !== 'undefined' && this.currCustomerUser.checkPassword !== null) {
            this.$refs.form.validateField('checkPassword')
          }
          callback()
        }
      }
      var validatePass2 = (rule, value, callback) => {
        if (typeof value === 'undefined' || value === null || value === '') {
          callback(new Error('请再次输入密码'))
        } else if (value !== this.currCustomerUser.password) {
          callback(new Error('两次输入密码不一致!'))
        } else {
          callback()
        }
      }

      var resetValidatePass = (rule, value, callback) => {
        if (typeof value === 'undefined' || value === null || value === '') {
          callback(new Error('请输入密码'))
        } else {
          if (this.resetCustomerUser.checkPassword !== '' && typeof this.resetCustomerUser.checkPassword !== 'undefined' && this.resetCustomerUser.checkPassword !== null) {
            this.$refs.resetForm.validateField('checkPassword')
          }
          callback()
        }
      }
      var resetValidatePass2 = (rule, value, callback) => {
        if (typeof value === 'undefined' || value === null || value === '') {
          callback(new Error('请再次输入密码'))
        } else if (value !== this.resetCustomerUser.password) {
          callback(new Error('两次输入密码不一致!'))
        } else {
          callback()
        }
      }
      return {
        receivingModeMap: {
          0: '不接收',
          1: '短信',
          2: '邮件',
          3: '短信+邮件'
        },
        pickerOptions: {
        },
        currentPage: 1,
        pagesize: 10,
        page: {},
        chooseTimes: [new Date(getCurrDayZero()), new Date(getCurrDayLast())],
        customerUsers: [],
        customerRoleMap: {},
        condition: {
          customerId: null,
          userType: 1,
          name: null,
          realName: null,
          mobile: null,
          enabled: null,
          customerRoleId: this.tenantId//业主用户角色id
        },
        // 添加编辑
        currCustomerUser: [],
        dialogVisible: false,
        rules: {
          name: [{ required: true, pattern: identifierRegex, message: '请输入正确的用户账号', trigger: 'blur' }, { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }],
          realName: [{ required: true, message: '用户姓名必填', trigger: 'blur' }, { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }],
          password: [{ validator: validatePass, required: true, trigger: 'blur' }, { pattern: /^[A-Za-z0-9_]{6,20}$/, message: '长度在 6 到 20 个字符', trigger: 'blur' }],
          checkPassword: [{ validator: validatePass2, required: true, trigger: 'blur' }],
          customerRoleIds: [{ required: true, message: '角色必选', trigger: 'change' }],
          enabled: [{ required: true, message: '启用状态必选', trigger: 'blur' }],
          mobile: [{ required: true, pattern: mobileRegex, message: '请输入正确的手机号', trigger: 'blur' }, { min: 11, max: 11, message: '长度为 11 个字符', trigger: 'blur' }],
          email: [{ required: true, pattern: emailRegex, message: '请输入正确的电子邮箱', trigger: 'blur' }, { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }],
          deadline: [{ required: true, message: '有效截止日期必填', trigger: 'blur' }]
        },
        // 重置密码数据
        resetDialogVisible: false,
        resetCustomerUser: [],
        resetRules: {
          password: [{ validator: resetValidatePass, required: true, trigger: 'blur' }, { pattern: /^[A-Za-z0-9_]{6,20}$/, message: '长度在 6 到 20 个字符', trigger: 'blur' }],
          checkPassword: [{ validator: resetValidatePass2, required: true, trigger: 'blur' }],
        },
        //业主用户id
        tenantId: null,
      }
    },
    computed: {
      ...mapGetters([
        'customerId'
      ])
    },
    mounted() {
      this.fetchData()
    },
    methods: {
      fetchData: function(isPage) {
        // 空字符串设为null
        if (this.condition.name !== null && this.condition.name.length === 0) {
            this.condition.name = null
        }

        if (this.condition.realName !== null && this.condition.realName.length === 0) {
            this.condition.realName = null
        }

        if (this.condition.mobile !== null && this.condition.mobile.length === 0) {
            this.condition.mobile = null
        }

        //console.log(this.condition.enabled)
        /*if (this.condition.enabled !== null && this.condition.enabled === 2) {
            delete this.condition.enabled
        }*/
        // 角色条件非空加入

        const customerRole = { customerId: this.customerId, code: 'user', enabled: 1}
        selectRoleByCode(customerRole).then(result => {
          if(result.code === 200){
            const roles = result.infoJson
            if(typeof roles !== 'undefined' && roles !== null && roles.length > 0){
              this.tenantId = roles[0].id
              this.condition.customerRoleId = roles[0].id
              this.condition.customerRoleIds = [roles[0].id]

              this.condition.customerId = this.customerId

              if (this.page.total) this.page.total = null
              if (!isPage) {
                this.page['current'] = 1
              }
              const myPage = { page: this.page, condition: this.condition }
              getCustomerUsers(myPage).then(res => {
                if (res.code === 200) {
                  const page = res.infoJson
                  this.customerUsers = page.records
                  this.page.total = page.total
                }
              }).catch(error => {
              })
            }else{
              Message({
                message: '没有查询到相关业主用户角色！',
                type: 'warning',
                duration: 5 * 1000
              })
            }
          }else{
            Message({
              message: '查询业主用户角色失败！',
              type: 'warning',
              duration: 5 * 1000
            })
          }
        })
      },
      getCustomerRoleNamesByIds: function(customerRoleIds) {
        const r = []
        if (customerRoleIds && this.customerRoleMap) {
          customerRoleIds.forEach(item => {
            if (this.customerRoleMap[item]) {
              r.push(this.customerRoleMap[item].name)
            }
          })
        }
        return r.join(',')
      },
      formatTime: function(time) {
        if (typeof time !== undefined && time !== null) {
          return formatToDay(time)
        } else {
          return time
        }
      },
      handleSizeChange: function(size) {
        this.page.size = size
        this.page.current = 1
        this.fetchData(true)
      },
      handleCurrentChange: function(currentPage) {
        this.page.current = currentPage
        this.fetchData(true)
      },
      currClick: function(val) {
        this.currCustomerUser = Object.assign({}, val)
      },
      edit: function() {
        if (typeof this.currCustomerUser.id === 'undefined' || this.currCustomerUser.id === null || this.currCustomerUser.id === '') {
          Message({
            message: '请选择用户',
            type: 'warning',
            duration: 5 * 1000
          })
          return
        }
        if (this.$refs.form) {
          this.$refs.form.clearValidate()
        }
        this.dialogVisible = true
      },
      add: function() {
        // this.currCustomerUser.id = null
        this.currCustomerUser = { id: null, enabled: 0, customerId: this.customerId, createDate: new Date(), customerRoleIds: [], mobile: null, email: null, alarmReceivingMode: 0, reportReceivingMode: 0 }
        if (this.$refs.form) {
          this.$refs.form.clearValidate()
        }
        this.dialogVisible = true
      },
      save: function() {
        this.$refs.form.validate(valid => {
          if (valid) {
            verifyCustomerUser(this.currCustomerUser).then(res => {
              if (res.code === 200) {
                if (res.infoJson) {
                  // 系统用户
                  this.currCustomerUser['userType'] = 1
                  this.currCustomerUser.customerRoleIds[0] = this.tenantId
                  console.log(this.currCustomerUser)
                  saveCustomerUser(this.currCustomerUser).then(res => {
                    if (res.code === 200) {
                      Message({
                        message: '操作成功',
                        type: 'success',
                        duration: 5 * 1000
                      })
                      this.currCustomerUser = []
                      this.dialogVisible = false
                      this.fetchData(true)
                    } else {
                      Message({
                        message: '操作失败',
                        type: 'error',
                        duration: 5 * 1000
                      })
                    }
                  })
                } else {
                  Message({
                    message: '该用户已存在',
                    type: 'warning',
                    duration: 5 * 1000
                  })
                }
              }
            })
          } else {
            console.log('error submit!!')
            return false
          }
        })
      },
      remove: function() {
          if (typeof this.currCustomerUser.id === 'undefined' || this.currCustomerUser.id === null || this.currCustomerUser.id === '') {
              Message({
                  message: '请选择用户',
                  type: 'warning',
                  duration: 5 * 1000
              })
              return
          }
          selectCustomerUserMeter(this.currCustomerUser.id).then(res =>{
              if (res.code === 200) {
                  if(res.infoJson.length>0){
                      let meterName = "";
                      for(var i = 0 ; i < res.infoJson.length; i ++){
                          meterName += res.infoJson[i].name + ","
                      }
                      meterName = meterName.substring(0,meterName.length-1)
                      //console.log(meterName)
                      Message({
                          message: "仪表[" + meterName + "]使用中，请解除仪表配置关系后重试！",
                          type: 'error',
                          duration: 5 * 1000
                      })
                  }else{
                      /*this.removeDialogVisible = true*/
                    MessageBox.confirm('删除业主用户后数据会永久丢失！谨慎删除！', '', {
                      confirmButtonText: '确定',
                      cancelButtonText: '取消',
                      type: 'warning'
                    }).then(() => {
                      this.deleteTenant()
                    })
                  }
              } else {
                  Message({
                      message: '操作失败',
                      type: 'error',
                      duration: 5 * 1000
                  })
              }
          })
      },
      deleteTenant: function() {
        const customerUser = {
          id: this.currCustomerUser.id,
          customerId: this.customerId
        }

          deleteCustomerUser(customerUser).then(res => {
          if (res.code === 200) {
            Message({
              message: '操作成功',
              type: 'success',
              duration: 5 * 1000
            })
          } else {
            Message({
              message: '操作失败',
              type: 'error',
              duration: 5 * 1000
            })
          }
          this.currCustomerUser = []
          this.fetchData()
        })
      },
      dialogResetPasswd: function() {
        if (typeof this.currCustomerUser.id === 'undefined' || this.currCustomerUser.id === null || this.currCustomerUser.id === '') {
          Message({
            message: '请选择用户',
            type: 'warning',
            duration: 5 * 1000
          })
          return
        }
        this.resetCustomerUser = {
          id: this.currCustomerUser.id,
          password: null,
          checkPassword: null
        }
        this.resetDialogVisible = true
      },
      resetPasswd: function() {
        this.$refs.resetForm.validate(valid => {
          if (valid) {
            updateCustomerUserSimp(this.resetCustomerUser).then(res => {
              if (res.code === 200) {
                Message({
                  message: '操作成功',
                  type: 'success',
                  duration: 5 * 1000
                })
                this.resetDialogVisible = false
                this.fetchData()
              } else {
                Message({
                  message: '操作失败',
                  type: 'error',
                  duration: 5 * 1000
                })
              }
            })
          } else {
            console.log('error submit!!')
            return false
          }
        })
      },
      handleSelectedFile (convertedData) {
          //去掉第一个对象
          convertedData.body.splice(0, 1)
          var customerUserArr = convertedData.body
          var adas = 0
          //校验客户用户
        if(typeof customerUserArr !== 'undefined' && customerUserArr !== null && customerUserArr.length > 0){
          for(var i = 0 ; i < customerUserArr.length ; i ++){
            //增加业主用户属性
            var customerUser = customerUserArr[i]
            if(typeof customerUser.deadline !== 'undefined' && customerUser.deadline !== null && customerUser.deadline !== ''){
              customerUser.deadline = new Date(customerUser.deadline)
            }else{
              customerUser.deadline = new Date()
            }
            if(typeof customerUser.password === 'undefined' || customerUser.password === null || customerUser.password === ''){
              customerUser['password'] = customerUser.mobile
            }
            customerUser.enabled = customerUser.enabled === '启用' ? 1 : 0
            customerUser.alarmReceivingMode = customerUser.alarmReceivingMode === '不接收' ? 0 : customerUser.alarmReceivingMode === '短信' ? 1 : customerUser.alarmReceivingMode === '邮件' ? 2 : 3
            customerUser["customerId"] = this.customerId
            customerUser["userType"] = 1
            var customerRoleIds = [this.tenantId]
            customerUser["createDate"] = new Date()
            customerUser["customerRoleIds"] = customerRoleIds
          }
          //console.log(customerUserArr)
          verifyBatchTenant(customerUserArr).then(res => {
              if (res.code === 200) {
                  var cuArr = res.infoJson
                  var name = ""
                  if(cuArr.length>0){
                      for(var i = 0 ; i < cuArr.length ; i ++ ){
                          for(var j = 0 ; j < customerUserArr.length ; j ++ ){
                              if(cuArr[i].name === customerUserArr[j].name){
                                  customerUserArr[j].id = cuArr[i].id
                              }
                          }
                      }
                      saveBatchTenant(customerUserArr).then(res => {
                          if (res.code === 200) {
                              Message({
                                  message: '操作成功',
                                  type: 'success',
                                  duration: 5 * 1000
                              })
                              this.dialogVisible = false
                              this.fetchData()
                          } else {
                              Message({
                                  message: '操作失败',
                                  type: 'error',
                                  duration: 5 * 1000
                              })
                          }
                      })
                  }else{
                      /*批量保存*/
                      saveBatchTenant(customerUserArr).then(res => {
                          if (res.code === 200) {
                              Message({
                                  message: '操作成功',
                                  type: 'success',
                                  duration: 5 * 1000
                              })
                              this.dialogVisible = false
                              this.fetchData()
                          } else {
                              Message({
                                  message: '操作失败',
                                  type: 'error',
                                  duration: 5 * 1000
                              })
                          }
                      })
                  }
              } else {
                  Message({
                      message: '操作失败',
                      type: 'error',
                      duration: 5 * 1000
                  })
              }
          })
        }else{
          Message({
            message: '业主用户为空',
            type: 'error',
            duration: 5 * 1000
          })
        }
      }
    }
  }
</script>

<style scoped rel="stylesheet/scss" lang="scss">
  .customer-User-manage-box {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;

    button {
      /*font-size: 14px;*/
      font-weight: bold;
    }

    .customer-User-condition-box {
      font-size: 14px;
      height: 60px;
      display: flex;
      align-items: center;
      padding-top: 15px;
      padding-left: 20px;
      box-sizing: border-box;
      .customer-User-search-button {
        margin-left: 10px;
      }
    }

    .div-hr {
      height: 1px;
      background-color: #dedede;
    }

    .op-box {
      padding-left: 20px;
      padding-top: 15px;
      padding-bottom: 15px;

      button {
        margin-right: 20px;
      }
    }

    .customer-User-table-box {
      flex:1;
    }

    .customer-User-page-box {
      height: 45px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .item-group {
      display: flex;
      div {
       padding-right: 20px;
      }
    }


  }
</style>

<style>
  .el-table th {
    background-color: #f5fafb;
  }
  .el-table__row--striped {
    background-color: #f4f3f3 !important;
  }

  .xlsx-button {
    display: inline-block !important;
    line-height: 1.3 !important;
    white-space: nowrap !important;
    cursor: pointer !important;
    border: 0.0625rem solid #00A5B2 !important;
    -webkit-appearance: none !important;
    text-align: center !important;
    box-sizing: border-box !important;
    outline: 0 !important;
    margin: 0 !important;
    transition: .1s !important;
    padding: 7px 9px !important;
    font-size: 0.75rem !important;
    font-weight: bold !important;
    border-radius: 0.25rem !important;
    color: #fff !important;
    background-color: #00A5B2 !important;
  }
  .download {
    display: inline-block ;
    line-height: 1.3 ;
    white-space: nowrap ;
    cursor: pointer ;
    border: 0.0625rem solid #00A5B2 ;
    -webkit-appearance: none ;
    text-align: center ;
    box-sizing: border-box ;
    outline: 0 ;
    margin: 0 ;
    transition: .1s ;
    padding: 7px 9px ;
    font-size: 0.75rem ;
    font-weight: bold ;
    color: #fff ;
    background-color: #00A5B2 ;
  }
</style>
